import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));
const AdminPage = lazy(() => import("../pages/admin/page"));
const GlazingCalculatorPage = lazy(() => import("../pages/glazing-calculator/page"));
const ProspectionPage = lazy(() => import("../pages/prospection/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "/calculateur-vitrage",
    element: <GlazingCalculatorPage />,
  },
  {
    path: "/prospection",
    element: <ProspectionPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;
